import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { SystemOverview } from './components/SystemOverview';
import { Categories } from './components/Categories';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { RatedTestimonials } from './components/RatedTestimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseProof } from './components/PurchaseProof';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '950420514112134';
interface AppProps {
  countdownHours?: number;
  showTestimonials?: boolean;
  showPurchaseProof?: boolean;
}
export function App({
  countdownHours = 3,
  showTestimonials = true,
  showPurchaseProof = true
}: AppProps) {
  useMetaPixel(META_PIXEL_ID);
  return <div className="w-full bg-cream-50 font-sans text-ink" data-id="element-0" data-mp="3mj6k9yvk64h1">
      <Hero data-id="element-1" data-mp="3rdkgu4lyihna" />
      {showTestimonials ? <RatedTestimonials data-id="element-2" data-mp="3relumgucxi8p" /> : null}
      <main data-id="element-3" data-mp="6htxpd5ixiv">
        <PainPoints data-id="element-4" data-mp="4wupmfw6qeo" />
        <ForWho data-id="element-5" data-mp="5ghbgghm2z1" />
        <SystemOverview data-id="element-6" data-mp="82jt1oitsae" />
        <Categories data-id="element-7" data-mp="2zld0l5ad579f" />
        <Tomos data-id="element-8" data-mp="2zlv7qwykd5w4" />
        <Bonuses data-id="element-9" data-mp="2zmeoiach9o8k" />
        <Comparison data-id="element-10" data-mp="2zmwit1fkxsdu" />
        <Offer countdownHours={countdownHours} data-id="element-11" data-mp="2zng2amkvootz" />
        <Guarantee data-id="element-12" data-mp="33nq5jrhad155" />
        <Testimonials data-id="element-13" data-mp="33n6wl09m5n39" />
        <Faq data-id="element-14" data-mp="33oi2p6qj76xj" />
        <FinalCta countdownHours={countdownHours} data-id="element-15" data-mp="38lrs4mdx7ild" />
      </main>
      <Footer data-id="element-16" data-mp="38kgmsi4tu2s5" />
      {showPurchaseProof ? <PurchaseProof data-id="element-17" data-mp="3dkl4gbhh13jy" /> : null}
    </div>;
}